module.exports = "<div class={%- classWidth %}> <div class=q-marg-vert-md-at-md> {%- channel %} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/globalHtml/channelColTemplate.html
// module id = 1131
// module chunks = 1